import { render, staticRenderFns } from "./SearchController.vue?vue&type=template&id=b20acfe4"
import script from "./SearchController.vue?vue&type=script&lang=js"
export * from "./SearchController.vue?vue&type=script&lang=js"
import style0 from "./SearchController.vue?vue&type=style&index=0&id=b20acfe4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports